import VaultedPaymentMethodIdParamDescriptionIos from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/VaultedPaymentMethodIdParamDescriptionIos.mdx";
import PrimerVaultedPaymentMethodAdditionalDataIos from "../../../../content/sdk/ios/2.x.x/_common/_props/PrimerVaultedPaymentMethodAdditionalDataIos.mdx";
import * as React from 'react';
export default {
  VaultedPaymentMethodIdParamDescriptionIos,
  PrimerVaultedPaymentMethodAdditionalDataIos,
  React
};